import { render } from "./icon18plus.vue?vue&type=template&id=4a3d7e6f&scoped=true&ts=true&class=icon18plus"
import script from "./icon18plus.vue?vue&type=script&lang=ts"
export * from "./icon18plus.vue?vue&type=script&lang=ts"

import "./icon18plus.vue?vue&type=style&index=0&id=4a3d7e6f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3d7e6f"]])

export default __exports__